import { Body, Flex, Icon, VStack } from '@hover/blueprint';
import { iChevronRight } from '@hover/icons';
import React from 'react';

import { ProductIcon } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/ProductIcon';
import type { Variation } from 'src/modules/designStudio/helpers/productSelection/types';

export type VariationSearchItemParams = {
  variation: Variation;
  onSelect: () => void;
};

export const VariationSearchItem = ({
  variation,
  onSelect,
  ...other
}: VariationSearchItemParams) => (
  <Flex
    alignItems="center"
    as="button"
    backgroundColor="neutral.0"
    borderStyle="none"
    direction="row"
    onClick={onSelect}
    {...other}
  >
    <ProductIcon
      as="div"
      borderRadius={900}
      color={variation.color ? variation.color.hex : 'neutral.0'}
      flex={3}
      height={500}
      isSelected={false}
      marginRight={400}
      marginTop={300}
      maxWidth={500}
      minWidth={500}
      thumbnail={variation.thumbnailURL!}
    />
    <Flex alignItems="start">
      <Flex direction="column" flex={3} justifyContent="center">
        {variation?.product?.provider?.name && (
          <VStack
            alignSelf="baseline"
            marginBottom={50}
            marginTop={400}
            textAlign="left"
          >
            <Body alignSelf="center" fontWeight="bold" my={0} size={400}>
              {variation.product.provider.name}
            </Body>
          </VStack>
        )}
        {variation.product.name && (
          <VStack alignSelf="baseline" marginBottom={50} textAlign="left">
            <Body alignSelf="center" color="neutral.600" my={0} size={400}>
              {variation.product?.name}
            </Body>
          </VStack>
        )}
        {variation.color && (
          <VStack alignSelf="baseline" textAlign="left">
            <Body alignSelf="center" color="neutral.600" my={0} size={400}>
              {variation.name}
            </Body>
          </VStack>
        )}
      </Flex>
    </Flex>
    <Icon flexShrink={0} icon={iChevronRight} marginLeft="auto" size="large" />
  </Flex>
);
